
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  TextField,
  Box,
  Paper,
  Stack,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  clearChannel,
  clearMessages,
  clearSelectedLanguage,
} from "app/store/fuse/conversationMessagesSlice";
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import socketConfig from "src/socketConfig";
import FuseLoading from "@fuse/core/FuseLoading";

const TextComponent = ({ sendPrompt, closeWS,language }) => {
  const [userInput, setUserInput] = useState("");
  const [isListening, setIsListening] = useState(false);
  const messages = useSelector((state) => state.fuse.conversations.messages);
  const channel = useSelector((state) => state.fuse.conversations.channel);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const { initializeAvatarSession,terminateAvatarSession,handleStreamDisconnected,handleSpeak ,sessionData} = socketConfig(videoRef); 

  const SpeechRecognition =
  window.SpeechRecognition || window.webkitSpeechRecognition;

if (!SpeechRecognition) {
  console.error("SpeechRecognition is not supported in this browser.");
} else {
  const recognition = new SpeechRecognition();
  recognition.lang = "en-US";
}
  const recognition = SpeechRecognition ? new SpeechRecognition() : null;
  useEffect(() => {
    if (!recognition) return;

    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang =
    language?.lang === "hindi"
        ? "hi-IN"
        : language?.lang  === "telugu"
        ? "te-IN"
        : "en-US";

    recognition.onresult = async (event) => {
      const transcript = event.results[0][0].transcript;
      
      setUserInput(transcript);
      sendPrompt(transcript);
      setUserInput("");
      setIsListening(false);
    };

    recognition.onend = () => setIsListening(false);
    recognition.onerror = (event) => {
      console.error("Speech recognition error:", event.error);
      setIsListening(false);
    };
  }, [recognition,language]);

  useEffect(() => {
    if (messages.length > 0) {
      const lastMessage = messages[messages.length - 1];

      if (lastMessage.type === "agent" && typeof lastMessage.message === "object" && lastMessage.message.token && channel == "ai_voice") {
        speakText(lastMessage.message.token,language);
      }else if(channel == "ai_avatar" && sessionData){
        handleSpeak(lastMessage.message.token)
      }
    }
  }, [messages,sessionData]);

  useEffect(() => {
    if (channel === "ai_avatar" && videoRef.current) {
      initializeAvatarSession();
      videoRef.current.play();
    }
  }, [channel,videoRef]);
  const synth = window.speechSynthesis;

  
  // const speakText = async (text, language) => {
  //   try {
  //     // Mapping of language codes to ElevenLabs voice IDs
  //     const voiceMap = {
  //       english: "fKzIqbE9IFXioiXLu93n",  
  //       hindi: "9nrGdUM3UnGeoIbHh5sn",  
  //       telugu: "6HLln48VEHiu9tWhifU2",  
  //     };
  
  //     const voiceId = voiceMap[language?.lang] || voiceMap["english"]; 
  //     const response = await fetch(
  //       `https://api.elevenlabs.io/v1/text-to-speech/${voiceId}`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "xi-api-key": "sk_32155d954dbf7f293c90e951b6f739e3025c836c5c85c0fb",
  //         },
  //         body: JSON.stringify({
  //           text,
  //           voice_id: voiceId,
  //         }),
  //       }
  //     );
  
  //     if (!response.ok) {
  //       throw new Error(`HTTP error! Status: ${response.status}`);
  //     }
  
  //     const audioBlob = await response.blob();
  //     const audioUrl = URL.createObjectURL(audioBlob);
  //     const audio = new Audio(audioUrl);
  //     audio.play();
  //   } catch (error) {
  //     console.error("Error generating speech with ElevenLabs:", error);
  //   }
  // };
  
  
  // Handle voice input

  const voiceMap = {
    telugu: {
      languageCode: 'te-IN',
      voiceName: 'te-IN-Chirp3-HD-Leda',
    },
    hindi: {
      languageCode: 'hi-IN',
      voiceName: 'hi-IN-Chirp3-HD-Leda',
    },
    english: {
      languageCode: 'en-IN',
      voiceName: 'en-IN-Chirp3-HD-Leda',
    },
  };
 const speakText = async (text, lang) => {
    const apiKey = "AIzaSyDXtHSuoRfs9PCKAuImb8WWWaHW3GDRkOE";
    const voice = voiceMap[lang?.lang.toLowerCase()] || voiceMap.english;
    try {
      const response = await fetch(
        `https://texttospeech.googleapis.com/v1/text:synthesize?key=${apiKey}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({input: { text },
            voice: {
              languageCode: voice.languageCode,
              name: voice.voiceName,
            },
            audioConfig: {
              audioEncoding: "MP3",
            },
          }),
        }
      );
      const data = await response.json();
      if (data.audioContent) {
        const audio = new Audio(`data:audio/mp3;base64,${data.audioContent}`);
        audio.play();
      } else {
        console.error("Google TTS Error:", data);
      }
    } catch (error) {
      console.error("Error with Google TTS:", error);
    }
  };
  
  const toggleMic = () => {
    if (isListening) {
      recognition?.stop();
      setIsListening(false);
    } else {
      recognition.start();
      // startListening();
      setIsListening(true);
    }
  };




  const handleSendClick = () => {
    if (userInput.trim()) {
      sendPrompt(userInput);
      setUserInput("");
    }
  };

  const handleEndSession = () => {
    closeWS();
    dispatch(clearMessages([]));
    dispatch(clearSelectedLanguage({}));
    dispatch(clearChannel());
    terminateAvatarSession()
    handleStreamDisconnected()
    synth.cancel();
    navigate("/knowledge_base");
  };

  return (
    <Box>
    <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
      <Box
        sx={{
          height: "65vh",
          overflowY: "auto",
          border: "1px solid",
          borderRadius: 1,
          p: 2,
          mb: 2,
        }}
      >
        {channel === "ai_avatar" ? (
          <article
            style={{
              width: "32vw" ,
              height: "55vh" ,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              position: "relative",
            }}
          >
            {!sessionData && (
              <FuseLoading style={{ display: "block", margin: "auto",justifyContent:'center',alignItems:'center' }} />)}
            <video
              ref={videoRef}
              id="avatarVideo"
              autoPlay
              playsInline
              style={{
                width:  "100%" ,
                height: "100%",
                objectFit: "contain",
                display: "block",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            ></video>
          </article>
        ) :  messages?.map((msg, index) => {
          let displayMessage = "";
          const isUserMessage = msg.type === "user";
          try {
            if (msg.type === "agent" && typeof msg.message === "object") {
              displayMessage = msg.message.token || "";
            } else {
              displayMessage = msg.message;
            }
          } catch (e) {
            console.error("Failed to parse agent message:", e);
            displayMessage = msg.message;
          }
  
          return (
            <Box
              key={index}
              sx={{
                display: "flex",
                justifyContent: isUserMessage ? "flex-end" : "flex-start",
                mb: 1,
              }}
            >
              <Box
                sx={{
                  p: 1,
                  borderRadius: 1,
                  maxWidth: 500,
                  bgcolor: isUserMessage ? "primary.main" : "grey.300",
                  color: isUserMessage ? "white" : "black",
                  wordWrap: "break-word",
                }}
              >
                {displayMessage}
              </Box>
            </Box>
          );
        })}
      </Box>
  
      <Stack direction="row" spacing={2} alignItems="center" sx={{ mt: 2 }}>
        {channel === "ai_voice" ? (
          // Voice Mode - Only Mic Button
          <IconButton onClick={toggleMic}>
            {isListening ? (
              <MicIcon sx={{ fontSize: 30, color: "red" }} />
            ) : (
              <MicOffIcon sx={{ fontSize: 30 }} />
            )}
          </IconButton>
        ) : (
          // AI Chat & Avatar Mode - Text Input & Buttons
          <>
            <TextField
              fullWidth
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
              placeholder="Type your message..."
              variant="outlined"
              disabled={channel === "ai_voice"}
            />
            <Button variant="contained" color="error" onClick={handleSendClick}>
              Send
            </Button>
          </>
        )}
        <Button  variant="outlined"  onClick={handleEndSession}>
          Close
        </Button>
      </Stack>
    </Paper>
  </Box>
  
  );
};

export default TextComponent;

